import BaseLayout from '@/components/BaseLayout.vue'
import {mapActions, mapGetters} from 'vuex';

export default {
    name: 'home',

    components: {
        BaseLayout
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),
    },

    methods: {
        ...mapActions('user', ['logout']),
    },
}